{
  "LOGIN": {
    "TITLE": "Prisijungimas prie Kontaktų centro",
    "EMAIL": {
      "LABEL": "El. paštas",
      "PLACEHOLDER": "example{'@'}companyname.com",
      "ERROR": "Prašau įveskite teisingą el. pašto adresą"
    },
    "PASSWORD": {
      "LABEL": "Slaptažodis",
      "PLACEHOLDER": "Slaptažodis"
    },
    "API": {
      "SUCCESS_MESSAGE": "Sėkmingai prisijungta",
      "ERROR_MESSAGE": "Nepavyko prisijungti prie Woot serverio. Bandykite dar kartą vėliau.",
      "UNAUTH": "Vartotojo vardas arba slaptažodis yra neteisingas. Prašome pabandyti dar kartą.",
      "ACCOUNT_DEACTIVATED": "Jūsų paskyra išjungta. Susisiekite su administratoriumi.",
      "PASSWORD_LOGIN_DISABLED": "Prisijungimas slaptažodžiu jūsų paskyrai išjungtas. Prisijunkite naudodami OAuth (pvz., Google)."
    },
    "OAUTH": {
      "GOOGLE_LOGIN": "Prisijungti su Google",
      "BUSINESS_ACCOUNTS_ONLY": "Norėdami prisijungti, naudokite savo įmonės el. pašto adresą",
      "NO_ACCOUNT_FOUND": "Nepavyko rasti paskyros pagal jūsų el. pašto adresą."
    },
    "FORGOT_PASSWORD": "Pamiršote slaptažodį?",
    "CREATE_NEW_ACCOUNT": "Sukurti naują paskyrą",
    "SUBMIT": "Prisijungti"
  }
}
